import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../Modal";
import { CheckBox, Input, Label, SelectInput, TextArea } from "../Form";
import { ButtonLoader } from "../Button";
import { useProjects } from "../../container/SelectProjectCompanyContainer";
import "./styles.scss"

export const formattedProjects = (projects = []) => {
  if(!projects || !projects.length) return [];

  return projects.map(project => ({ value: project?.id, label: project?.description}))
}

export const EsmModal = ({
  modalIsOpen,
  setModalIsOpen,
  dw,
  values,
  onChangeValues,
  isUpdate,
  register,
  control,
  saveNewESM,
  updateESM,
  handleSelectAll,
  isAllProjectSelected
}) => {
  const { projects } = useProjects();

  return (
    <ModalPanel modalIsOpen={modalIsOpen}>
      <ModalHeader
        closeModal={() => setModalIsOpen(false)}
        title={`${isUpdate ? "Editar Esm" : "Novo Esm"}`}
      />
      <ModalBody>
        <div className="complete-esm-modal">
          <div className="complete-esm-modal-col-left">
          <Label label="Título">
            <Input
              name="title"
              placeholder="Insira aqui o título"
              register={register("title")}
              defaultValue={values?.title}
            />
          </Label>
          <Label label="Descrição">
            <TextArea
              register={register("description")}
              name="description"
              placeholder="Insira aqui a descrição"
              resize="none"
              defaultValue={values?.description}
            />
          </Label>
          {/* <Label label="Configurações de Layout">
            <TextArea
              register={register("config")}
              name="config"
              placeholder="Insira aqui a configuração em JSON"
              resize="none"
              defaultValue={values?.config}
            />
          </Label> */}
          </div>
          <div className="complete-esm-modal-col-right">
            <Label label={"Projetos"}>
              <SelectInput
                handleChange={onChangeValues("projects")}
                closeMenuOnSelect={false}
                isSearchable={true}
                isClearable={false}
                isMulti={Array.isArray(projects) && projects?.length > 0}
                name="projects"
                options={Array.isArray(projects) ? formattedProjects(projects) : []}
                control={control}
                value={values?.projects || []}
                defaultValue={values?.projects}
                isOverModal={true}
              />
            </Label>
            <CheckBox 
              label="Selecionar todos os projetos"
              checked={isAllProjectSelected}
              onChange={handleSelectAll}
            />
          </div>
        </div>
        
      </ModalBody>
      <ModalFooter>
          <ButtonLoader
            handleClick={isUpdate ? updateESM : saveNewESM}
            label={!isUpdate ? "Salvar" : "Alterar"}
            color="orange"
          />
        </ModalFooter>
    </ModalPanel>
  )
}